import branchInfoMenu from "./menuItems/branchInfoMenu.js";
import documentsMenu from "./menuItems/documentsMenu.js";
import servicesMenu from "./menuItems/servicesMenu.js";

export default {
    branchInfoMenu: branchInfoMenu,
    servicesMenu: servicesMenu,
    documentsMenu: documentsMenu,
}